import { Box, Typography } from "@mui/material";
import React from "react";

type Props = {
  date: string;
  title: string;
  episodeNo: number;
  length?: string;
  imageUrl: string;
  onClick?: () => void;
};

const LatestPodcastCard = ({
  date,
  title,
  episodeNo,
  length,
  imageUrl,
  onClick,
}: Props) => {
  const formattedLength = React.useMemo(() => {
    if (!length) return "";

    const value = Number(length);

    const mins = Math.floor(value);
    const secs = Math.round((value - mins) * 100);

    if (mins < 60) {
      return secs > 0 ? `${mins} mins ${secs} secs` : `${mins} mins`;
    }

    const hrs = Math.floor(mins / 60);
    const remainingMins = mins % 60;

    return secs > 0
      ? `${hrs} hr ${remainingMins} mins ${secs} secs`
      : `${hrs} hr ${remainingMins} mins`;
  }, [length]);

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "16px",
        width: "100%",
        py: 1.5,
        cursor: onClick ? "pointer" : "default",
        "&:last-child": { borderBottom: "none" },
        "&:hover": onClick ? { opacity: 0.85 } : {},
        transition: "opacity 0.15s",
      }}
    >
      {/* Thumbnail */}
      <Box
        sx={{
          width: { xs: 80, sm: 100 },
          minWidth: { xs: 80, sm: 100 },
          height: { xs: 65, sm: 75 },
          borderRadius: "8px 0 0 8px",
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          flexShrink: 0,
          zIndex: 100,
        }}
      />

      {/* Text */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        {/* Episode + Title */}
        <Typography
          variant="body2"
          fontSize={{ xs: "13px", sm: "14px" }}
          lineHeight="1.45"
          color="white"
          fontWeight={400}
        >
          <Box
            component="span"
            className=" font-areaBlack"
            sx={{ fontWeight: 600 }}
          >
            {episodeNo ? `Ep ${episodeNo}:` : ""}
          </Box>{" "}
          {title}
        </Typography>

        {/* Date · length */}
        <Typography
          variant="body2"
          fontSize={{ xs: "12px", sm: "13px" }}
          color="rgba(255,255,255,0.75)"
          fontStyle="italic"
          lineHeight="1.6"
        >
          {date}
          {formattedLength ? ` • ${formattedLength}` : ""}
        </Typography>
      </Box>
    </Box>
  );
};

export default LatestPodcastCard;
